import { waitForFetch } from '@ember/test-waiters';
import { isTesting, macroCondition } from '@embroider/macros';
import * as changeKeys from 'change-case/keys';
import { isPlatformLocalDomain } from 'frontend-utils/utils/domain-checks';
import Cookies from 'js-cookie';

export class NetworkError extends Error {
  declare cause: { response: Response };
  name = 'NetworkError';

  constructor(message: string, options: { cause: { response: Response } }) {
    super(message, options);
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function extendInit(options: RequestInit = {}) {
  if (isPlatformLocalDomain()) {
    options.credentials = 'include';
  }

  if (macroCondition(isTesting())) {
    return options;
  }

  const csrftoken = Cookies.get('csrftoken');

  if (options.method && csrftoken && isWriteOperation(options.method)) {
    options.headers = {
      'X-CSRFToken': csrftoken,
      ...options.headers,
    };
  }

  return options;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function isWriteOperation(method: string) {
  return !/^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default async function fetch(
  input: RequestInfo | URL,
  init?: RequestInit,
) {
  const response = await waitForFetch(window.fetch(input, extendInit(init)));

  // Manually throw error since fetch does not throw by default
  if (!response.ok) {
    throw new NetworkError('Network response was not ok', {
      cause: { response },
    });
  }

  const noContent = response.status === 204;
  if (noContent) {
    return;
  }

  // All API's should return JSON
  const data: unknown = await response.json();

  return changeKeys.camelCase(data, Infinity);
}
